import React, { useState } from 'react';
// import './deleteMediaDialog.css';
import "./capchaDelete.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

function CapchaDeleteMediaDialog({ onClose, onConfirm, msg = "DELETE" }) {
  const [inputValue, setInputValue] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleCancel = () => {
    onClose();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsConfirmed(value === msg);
  };

  const handleConfirm = () => {
    if (isConfirmed) {
      onConfirm();
    }
  };

  return (
    // <div className="dialog-container">
      <div >
        {/* <FontAwesomeIcon icon={faTrash} className="trash-icon" /> */}
        <h4 className="dialog-title">Confirm Deletion</h4>
        <p className="dialog-message">
          Are you sure you want to delete User Data ? This action cannot be undone. 
          Please type <strong>{msg}</strong> in the box below to confirm.
        </p>
        <input 
          type="text" 
          placeholder={`Type "${msg}" to confirm`} 
          value={inputValue} 
          onChange={handleChange} 
          className="confirmation-input" 
        />
        <div className="button-group">
          <button className="btn btn-light" onClick={handleCancel}>
            Cancel
          </button>
          <button 
            className="btn btn-danger" 
            onClick={handleConfirm} 
            disabled={!isConfirmed}
          >
            Confirm
          </button>
        </div>
      </div>
    // </div>
  );
}

export default CapchaDeleteMediaDialog;
